import { render, staticRenderFns } from "./Receipt-payment-methods.vue?vue&type=template&id=9c5124d4&scoped=true"
import script from "./Receipt-payment-methods.vue?vue&type=script&lang=js"
export * from "./Receipt-payment-methods.vue?vue&type=script&lang=js"
import style0 from "./Receipt-payment-methods.vue?vue&type=style&index=0&id=9c5124d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5124d4",
  null
  
)

export default component.exports